var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Edit"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\xF0\x9F\x8E\xA8 Color",
    d: "M16.717 3.28297C17.761 4.32693 17.761 6.01952 16.717 7.06348L7.77622 16.0043C7.56938 16.2111 7.31214 16.3604 7.02994 16.4374L3.20832 17.4796C2.79007 17.5937 2.40629 17.2099 2.52036 16.7917L3.56262 12.9701C3.63959 12.6879 3.78887 12.4306 3.9957 12.2238L12.9365 3.28297C13.9805 2.23901 15.6731 2.23901 16.717 3.28297ZM12.2123 5.592L4.78806 13.0161C4.71911 13.0851 4.66935 13.1708 4.6437 13.2649L3.85942 16.1406L6.7351 15.3563C6.82917 15.3306 6.91491 15.2809 6.98386 15.2119L14.4078 7.78755L12.2123 5.592ZM13.7289 4.07533L13.0041 4.79939L15.1997 6.99568L15.9247 6.27113C16.531 5.66477 16.531 4.68168 15.9247 4.07533C15.3183 3.46897 14.3352 3.46897 13.7289 4.07533Z",
    fill: "#1D72E9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.35c2b91dcdefcd5116ce88bddafe23f8.svg";
export { ForwardRef as ReactComponent };